/*
* 
* This is the same thing as runtime but the info is downloaded from id.net
* 
*/
define('options',['utils/constants', 'runtime', 'sdk/api', 'event', 'logger', 'utils/cookies'],
function(CONST, Runtime, API, Event, Logger, Cookies){
  return {
    get: {},
    update: function(){
      var self = this;
      var optionsCache = Cookies.getCookie('co'+Runtime.__options.appId);
      if(optionsCache){
        try{
          optionsCache = JSON.parse(optionsCache);
          self.get = optionsCache;
          Event.fire('options');
        }catch(e){
          Logger.log('options cache failed', e);
        }
        return;
      }

      API.apiOpen('client_options/'+Runtime.getAppId(), 'GET', null, function(data){
        if(data.success){
          self.get = data.options;
          Cookies.setCookie('co'+Runtime.__options.appId, JSON.stringify(data.options), 10);
          Event.fire('options');
        }else{
          Logger.log(data);
        }
      });
    },
    reset: function() {
      this.get = {};
      Cookies.setCookie('co'+Runtime.__options.appId, '', -1);
    }
  }
});

